import { LegalPage } from './LegalPage';

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated="2026-05-13">
      <div className="legal__draft-banner">
        DRAFT — Replace this template with reviewed legal copy before submitting MeetFlow to Microsoft AppSource. Page exists at /privacy so the Teams app manifest resolves correctly.
      </div>

      <p>
        This Privacy Policy describes how Ananeos ("we", "us", "our") handles information when you use the MeetFlow application
        ("MeetFlow", the "Service") inside Microsoft Teams.
      </p>

      <h2>1. Data we access</h2>
      <p>
        MeetFlow runs as a Microsoft Teams Tab and operates on data inside your organization's Microsoft 365 tenant via the
        Microsoft Graph API. Specifically:
      </p>
      <ul>
        <li><strong>Your profile information</strong>: name, email, and avatar (via the <code>User.Read</code> Graph scope).</li>
        <li><strong>Channel membership</strong>: to identify session attendees (<code>ChannelMember.Read.All</code>).</li>
        <li><strong>SharePoint lists</strong>: MeetFlow creates and reads one list per Teams channel inside your team's auto-provisioned SharePoint site (<code>Sites.ReadWrite.All</code>, <code>Sites.Manage.All</code>).</li>
        <li><strong>Microsoft Planner tasks</strong>: MeetFlow creates and updates tasks in your team's Planner plan when agreements are recorded (<code>Tasks.ReadWrite</code>, <code>GroupMember.Read.All</code>).</li>
      </ul>

      <h2>2. Where your data is stored</h2>
      <p>
        All meeting data created by MeetFlow — agendas, notes, agreements, attendee lists — is stored in your own Microsoft 365
        tenant: in SharePoint lists and Microsoft Planner. Ananeos does not host or replicate this data on its own servers.
      </p>

      <h2>3. Authentication</h2>
      <p>
        MeetFlow uses Microsoft Teams Single Sign-On and exchanges your Teams identity token for a Microsoft Graph access token
        via the On-Behalf-Of flow. The Graph access token is used only to perform the read/write operations described above and
        is not persisted by Ananeos.
      </p>

      <h2>4. What we do not collect</h2>
      <ul>
        <li>We do not store meeting content on Ananeos servers.</li>
        <li>We do not sell, rent, or share any data with third parties.</li>
        <li>We do not use your meeting content to train AI models.</li>
      </ul>

      <h2>5. Telemetry</h2>
      <p>
        MeetFlow may collect minimal anonymous telemetry (e.g. error reports, page load timing) to maintain service quality.
        This telemetry contains no personal data and no meeting content.
      </p>

      <h2>6. Data retention &amp; deletion</h2>
      <p>
        Because your meeting data lives in your tenant, retention is governed by your Microsoft 365 retention policies. To remove
        MeetFlow data, an administrator can delete the SharePoint lists named <code>MeetFlow — &lt;channel&gt;</code> and the Planner
        tasks created by MeetFlow.
      </p>

      <h2>7. Your rights</h2>
      <p>
        Because Ananeos does not host your meeting data, requests to access, correct, or delete data should be directed to your
        organization's Microsoft 365 administrator. For questions about Ananeos's data practices, contact{' '}
        <a href="mailto:privacy@ananeos.com">privacy@ananeos.com</a>.
      </p>

      <h2>8. Changes</h2>
      <p>
        We will update this Privacy Policy as MeetFlow evolves. The "Last updated" date at the top reflects the most recent
        revision.
      </p>

      <h2>9. Contact</h2>
      <p>
        Ananeos<br />
        <a href="mailto:privacy@ananeos.com">privacy@ananeos.com</a>
      </p>
    </LegalPage>
  );
}
